import MainPage from 'feature/main';
import ProfileSetting from 'feature/profile-setting';
import Settings from 'feature/settings';
import OrderPage from 'feature/orders';
import OrderDetailsPage from 'feature/orders/details';
import { LoginFlowProvider } from 'feature/login-flow/use-login-flow';
import WelcomePage from 'feature/login-flow/welcome';
import LoginPage from 'feature/login-flow/login-page';
import RegisterPage from 'feature/login-flow/register';
import EnableOnStreetParkingAutoPayPage from 'feature/login-flow/enable-on-street-parking-auto-pay';
import AddPlateNumberPage from 'feature/login-flow/add-plate-number';
import BindCard from 'feature/login-flow/bind-card';
import OnStreetParkingAutoPayNoticePage from 'feature/login-flow/on-street-parking-auto-pay-notice';
import { PATH } from 'config';
import { ReceiptProvider } from 'feature/receipt/use-receipt';
import Receipt from 'feature/receipt';
import ReceiptDonate from 'feature/receipt/types/receipt-donate';
import { StreetParkingProvider } from 'feature/street-parking/use-street-parking';
import StreetParkingAutopay from 'feature/street-parking/street-parking-autopay';
import StreetParkingCities from 'feature/street-parking/street-parking-cities';
import StreetParkingPlates from 'feature/street-parking/street-parking-plates';
import StreetParkingBills from 'feature/street-parking/street-parking-bills';
import { LicensePlatesProvider } from 'feature/license-plates/use-license-plate';
import LicensePlates from 'feature/license-plates';
import NewLicensePlate from 'feature/license-plates/new-license-plate';
import EditLicensePlate from 'feature/license-plates/edit-license-plate';
import MochiPaySetting from 'feature/mochi-pay-flow/setting';
import MochiPayCreditCard from 'feature/mochi-pay-flow/credit-card';
import { MochipayFlowProvider } from 'feature/mochi-pay-flow/use-mochi-pay-flow';
import ServiceInstruction from 'feature/service-instruction';
import MapsPage from 'feature/maps';
import coins from 'feature/coins';
import Contact from 'feature/contact';

const Routing = [
  { path: PATH.MAIN, component: MainPage },
  { path: PATH.MAPS, component: MapsPage },
  { path: PATH.COINS, component: coins },
  { path: PATH.PROFILE_SETTING, component: ProfileSetting },
  { path: PATH.SETTINGS, component: Settings },
  { path: PATH.ORDERS, component: OrderPage },
  { path: PATH.ORDER_DETAIL, component: OrderDetailsPage },
  { path: PATH.SERVICE_INSTRUCTION, component: ServiceInstruction },
  { path: PATH.CONTACT, component: Contact },
  {
    path: PATH.USER_INDEX,
    provider: LoginFlowProvider,
    routes: [
      { path: PATH.USER_WELCOME, component: WelcomePage },
      { path: PATH.USER_LOGIN, component: LoginPage },
      { path: PATH.USER_REGISTER, component: RegisterPage },
      { path: PATH.USER_ENABLE_ON_STREET_PARKING_AUTO_PAY, component: EnableOnStreetParkingAutoPayPage },
      { path: PATH.USER_ADD_PLATE_NUMBER, component: AddPlateNumberPage },
      { path: PATH.USER_BIND_CARD, component: BindCard },
      { path: PATH.USER_ON_STREET_PARKING_AUTO_PAY_NOTICE, component: OnStreetParkingAutoPayNoticePage },
    ],
  },
  {
    path: PATH.PATH_RECEIPT_INDEX,
    provider: ReceiptProvider,
    routes: [
      { path: PATH.RECEIPT_INDEX, component: Receipt },
      { path: PATH.RECEIPT_DONATE, component: ReceiptDonate },
    ],
  },
  {
    path: PATH.STREET_PARKING_INDEX,
    provider: StreetParkingProvider,
    routes: [
      { path: PATH.STREET_PARKING_AUTOPAY, component: StreetParkingAutopay },
      { path: PATH.STREET_PARKING_CITIES, component: StreetParkingCities },
      { path: PATH.STREET_PARKING_PLATES, component: StreetParkingPlates },
      { path: PATH.STREET_PARKING_BILLS, component: StreetParkingBills },
    ],
  },
  {
    path: PATH.LICENSE_PLATES_INDEX,
    provider: LicensePlatesProvider,
    routes: [
      { path: PATH.LICENSE_PLATES_INDEX, component: LicensePlates },
      { path: PATH.LICENSE_PLATES_NEW, component: NewLicensePlate },
      { path: PATH.LICENSE_PLATES_EDIT, component: EditLicensePlate },
    ],
  },
  {
    path: PATH.MOCHIPAY_FLOW_INDEX,
    provider: MochipayFlowProvider,
    routes: [
      { path: PATH.MOCHIPAY_FLOW_SETTING, component: MochiPaySetting },
      { path: PATH.MOCHIPAY_FLOW_CREDIT_CARD, component: MochiPayCreditCard },
    ],
  },
];

export default Routing;
